import React from "react";
import { useNavigate } from "react-router";
import { AppRoutes } from "../../utils/routes";

import "./scss/ErrorPage.scss";

const NotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate(AppRoutes.getExactRoute(AppRoutes.home));
  };

  return (
    <div className="main-container not-found-container">
      <h1>Page not found</h1>
      <h5>The page you are looking for does not exist or has been moved</h5>
      <button className="button-primary" onClick={goHome}>
        Go back to home page
      </button>
    </div>
  );
};

export default NotFound;
